import logo from "../../asserts/images/logos/Colour_Trans_Horizontal.svg";
import facebook from "../../asserts/images/facebook.png";
import whatsapp from "../../asserts/images/whatsapp.png";
import linkedin from "../../asserts/images/linkedin.png";
import instagram from "../../asserts/images/instagram.png";
import mail from "../../asserts/images/mail.png";
import location from "../../asserts/images/location_on.png";
import call from "../../asserts/images/call.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "./footer.scss";

const Footer = () => {
  return (
    <div>
      <footer className="divone bg-dark ">
        <div className="row text-light">
          <div className="col-lg-4 col-md-12 ">
            <div className="center con">
              <img src={logo} alt="" className="mb-4" />
              <p className="lh-base">
                Pagirndhunn is a nonprofit committed to eradicating <br />
                hunger by providing food relief to underprivileged
                <br />
                communities across India. Together, we can make <br />
                hunger history.
              </p>

              <div className="mt-4">
                <img src={facebook} alt="" className="pe-4" />
                <img src={whatsapp} alt="" className="pe-4" />
                <img src={linkedin} alt="" className="pe-4" />
                <img src={instagram} alt="" className="pe-4" />
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-12 ">
            <div className="center con">
              <h4>Quick Links</h4>
              <a href="#">About Us</a>
              <br />
              <a href="#">Gallery</a>
              <br />
              <a href="#">Terms And Conditions</a>
              <br />
              <a href="#">Privacy And Policy</a>
            </div>
          </div>
          <div className="col-lg-3 col-md-12">
            <div className="center con">
              <h4>Contact Us</h4>
              <label>
                <div>
                  <img src={mail} alt="" />
                </div>{" "}
                <div>
                  <a href="mailto:pagirndhunn@gmail.com" style={{ color: "inherit", textDecoration: "none" }}>
                    pagirndhunn@gmail.com
                  </a>
                </div>
              </label>
              <label>
                <div>
                  <img src={call} alt="" />
                </div>{" "}
                <div>
                  <a href="tel:+919597453137" style={{ color: "inherit", textDecoration: "none" }}>+91 9597453137</a> |
                  <a href="tel:+917200187832" style={{ color: "inherit", textDecoration: "none" }}> 7200187832</a>
                </div>
              </label>

              <label>
                <div>
                  <img src={location} alt="" />
                </div>
                <div>
                  No. 186, Thendral Nagar, Abraham Pandithar Nagar, 5th cross, Thanjavur - 613004
                </div>
              </label>
            </div>
          </div>
          <div className="col-lg-2 col-md-12">
            <div className="center con">
              <h4>Useful Links</h4>
              <a href="#">Report Bugs</a>
              <br />
              <a href="#">Contact Us</a>
            </div>
          </div>
        </div>
      </footer>
      <div className="Copyright bg-dark">
        <p className="mb-0">
          Copyright © 2025 Pagirndhun. All rights reserved.
        </p>
      </div>
    </div>
  );
};
export default Footer;
